import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { BulkMatchPaymentsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createBulkMatchPayment = (data): any => action(types.CREATE_BULK_MATCH_PAYMENT_REQUESTED, data);

export const updateBulkMatchPayment = (data): any => action(types.UPDATE_BULK_MATCH_PAYMENT_REQUESTED, data);

export const deleteBulkMatchPayment = (bulkMatchPaymentId): any => action(types.UPDATE_BULK_MATCH_PAYMENT_REQUESTED, bulkMatchPaymentId);

export const getBulkMatchPayment = (bulkMatchPaymentId): any => action(types.GET_BULK_MATCH_PAYMENT_REQUESTED, bulkMatchPaymentId);

export const getAllBulkMatchPayments = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_BULK_MATCH_PAYMENTS_REQUESTED, { pagination, compile });

export const selectBulkMatchPayment = (bulkMatchPaymentId): any => action(types.SELECT_BULK_MATCH_PAYMENT_REQUESTED, {
  currentBulkMatchPaymentId: bulkMatchPaymentId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createBulkMatchPaymentPending: (payload): any => action(types.CREATE_BULK_MATCH_PAYMENT_PENDING, payload),
  createBulkMatchPaymentSuccess: (response): any => {
    const currentBulkMatchPayment = response.entities.bulkMatchPayments[response.result];

    history.push(`/payment/multiple-matches/${currentBulkMatchPayment.id}/review`);
    return action(types.CREATE_BULK_MATCH_PAYMENT_SUCCESS, {
      bulkMatchPaymentsById: response.entities.bulkMatchPayments,
      currentBulkMatchPaymentId: response.result,
    });
  },
  updateBulkMatchPaymentPending: (payload): any => action(types.UPDATE_BULK_MATCH_PAYMENT_PENDING, payload),
  updateBulkMatchPaymentSuccess: (response): any => action(types.UPDATE_BULK_MATCH_PAYMENT_SUCCESS, {
    bulkMatchPaymentsById: response.entities.bulkMatchPayments,
    currentBulkMatchPaymentId: response.result,
  }),
  updateBulkMatchPaymentFailed: (error): any => action(types.UPDATE_BULK_MATCH_PAYMENT_FAIL, { backendErrors: error }),
  deleteBulkMatchPaymentPending: (): any => action(types.UPDATE_BULK_MATCH_PAYMENT_PENDING, {}),
  deleteBulkMatchPaymentSuccess: (response, userId): any => action(types.DELETE_BULK_MATCH_PAYMENT_SUCCESS, {
    currentBulkMatchPaymentId: response,
  }),
  getBulkMatchPaymentPending: (): any => action(types.GET_BULK_MATCH_PAYMENT_PENDING, {}),
  getBulkMatchPaymentSuccess: (response): any => action(types.GET_BULK_MATCH_PAYMENT_SUCCESS, {
    bulkMatchPaymentsById: response.entities.bulkMatchPayments,
    currentBulkMatchPaymentId: response.result,
  }),
  getBulkMatchPaymentFailed: (error): any => action(types.GET_BULK_MATCH_PAYMENT_FAIL, { backendErrors: error }),
  deleteBulkMatchPaymentFailed: (error): any => action(types.UPDATE_BULK_MATCH_PAYMENT_FAIL, { backendErrors: error }),
  getAllBulkMatchPaymentsPending: (pagination): any => action(types.GET_ALL_BULK_MATCH_PAYMENTS_PENDING, { pagination }),
  getAllBulkMatchPaymentsSuccess: (response, meta): any => action(types.GET_ALL_BULK_MATCH_PAYMENTS_SUCCESS, {
    bulkMatchPaymentsById: response.entities.bulkMatchPayments,
    bulkMatchPaymentIds: response.result,
    meta,
  }),
  getAllBulkMatchPaymentsFailed: (error): any => action(types.GET_ALL_BULK_MATCH_PAYMENTS_FAIL, { backendErrors: error }),
  createBulkMatchPaymentFailed: (error): any => action(types.CREATE_BULK_MATCH_PAYMENT_FAIL, { backendErrors: error }),
};

export default null;
